import * as React from 'react';
import { Button, Form, Modal, Select } from 'antd';
import { GenerateCSTokenRequest } from '../../../models/generate-cs-token-request-interface';
import { Formik, FormikProps } from "formik";
import { useRef, useState } from 'react';
import * as Yup from 'yup';
import TextArea from 'antd/lib/input/TextArea';
import { UseMutationResult } from '@tanstack/react-query';

const { Option } = Select;

type Props = {
  isVisible: boolean,
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>,
  handleSubmit: Function,
  grantAccessMutation: UseMutationResult<any, unknown, GenerateCSTokenRequest, unknown>
}

const GrantAccessModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  grantAccessMutation
}) => {
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const formRef = useRef<FormikProps<any>>(null);
 

  return (
    <Modal
      centered
      title="Grant Account Access"
      visible={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={[
        <Button id="cancelGrantAccessButton" type="text" key="cancel" onClick={() => setIsVisible(false)}>
          Cancel
        </Button>,
        <Button id={`grantAccessButton`} type="primary" key="submit" htmlType="submit" form="grantAccessForm" loading={grantAccessMutation.isLoading} disabled={!canSubmit}>
          Grant Access
        </Button>
      ]}
      destroyOnClose
    >
      <p>Grant support access to this account. Please obtain express permission from the user before taking this action. Note the user will be notified of this access.</p>
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={{
          expirationDaysFromNow: 1,
          reason: ''
        }}
        onSubmit={(val) => handleSubmit(val)}
        validationSchema={
          Yup.object().shape({
            expirationDaysFromNow: Yup.number().required(),
            reason: Yup.string().required('Please input reason')
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue
        }) => (
          <Form
            id="grantAccessForm"
            onFinish={handleSubmit}
            layout="vertical"
          >
            <Form.Item
              label="Access Option"
              required
            >
              <Select
                className="full-width"
                value={values.expirationDaysFromNow}
                onChange={(val) => setFieldValue('expirationDaysFromNow', val)}
                onBlur={handleBlur}
              >
                <Option value="1">1 day</Option>
                <Option value="7">1 week</Option>
                <Option value="30">30 days</Option>
                <Option value="60">60 days</Option>
                <Option value="365">1 year</Option>
              </Select>              
            </Form.Item>

            <Form.Item
              className="full-width"
              label="Reason"
              name="reason"
              help={(touched.reason && errors.reason ? errors.reason : null)}
              validateStatus={touched.reason && errors.reason ? 'error' : ''}
              required
            >
              <TextArea
                rows={2}
                value={values.reason}
                onChange={(e) => {
                  handleChange(e);
                  setCanSubmit(e.target.value.length ? true : false);
                }}
                onBlur={handleBlur}
                disabled={grantAccessMutation.isLoading}
              />
            </Form.Item>
          </Form>
        )}
      </Formik>
    </Modal>
  )
};

export default GrantAccessModal;